/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IReportProcessScope extends angular.IScope {
        model: models.ReportProcessModel
    }

    export class ReportProcessController implements IController {
        constructor(
            private scope: IReportProcessScope,
            $location: angular.ILocationService,
            $rootScope: angular.IRootScopeService,
            $filter: angular.IFilterService,
            localStorageService: any,
            processTypeService: services.ProcessTypeService,
            cacheConfigurationService: services.ConfigurationCacheService,
            $routeParams: angular.route.IRouteParamsService,
            processService: services.ProcessService,
            modalService: any, formDataService: services.FormDataService,
            signalRService: services.SignalrService,
            growl: angular.growl.IGrowlService, conditionService: services.ConditionService,
            userService: services.UserService,
            objectQueryService: services.ObjectQueryService) {
            var processTypeId = $routeParams["id"];
            var processId = $routeParams["processId"];
            var formId = $routeParams["formId"];
            var formDataId = $routeParams["formDataId"];
            var parentFormDataId = $routeParams["parentFormDataId"];
            var parentFormId = $routeParams["parentFormId"];
            var parentFormName = $routeParams["parentFormName"];

            this.scope.model = new models.ReportProcessModel(
                $location,
                $rootScope,
                $filter,
                localStorageService,
                processTypeId,
                processId,
                processTypeService,
                processService,
                cacheConfigurationService,
                modalService, formDataService, signalRService, growl, conditionService, userService, objectQueryService, scope, formId, formDataId, parentFormId, parentFormDataId, parentFormName);
        }
    }
}

warsApp.registerController('ReportProcessController', ['$scope', '$location', '$rootScope', '$filter', 'localStorageService', 'processTypeService', 'configurationCacheService', '$routeParams', 'processService', 'ModalService', 'formDataService', 'signalrService', 'growl', 'conditionService', 'userService', 'objectQueryService']);